export const RESTO365_RESTAURANT = 'RESTO365_RESTAURANT'

export const RESTO365_RESTAURANT_CREATE = `${RESTO365_RESTAURANT}/createResto365Store`

export const RESTO365_ALL_RESTAURANT = `${RESTO365_RESTAURANT}/getRestro`

export const RESTO365_ADMIN_LIST_RESTAURANT = `${RESTO365_RESTAURANT}/getAdminListRestro`

export const EXPORT_RESTO365_RESTAURANT = `${RESTO365_RESTAURANT}/exportRestro`

export const RESTO365_NRO_RESTAURANT = `${RESTO365_RESTAURANT}/getNroRestro`

export const RESTO365_PERM_CLOSED_RESTAURANT = `${RESTO365_RESTAURANT}/getPermClosedRestro`

export const RESTO365_GET_RESTAURANT_BY_BHYVE_ID = `${RESTO365_RESTAURANT}/get365RestroByBhyveID`

export const RESTO365_GET_RESTAURANT_BY_ID = `${RESTO365_RESTAURANT}/get365RestroById`

export const RESTO365_GET_FRANCHISE_RESTAURANTS_BY_IDS = `${RESTO365_RESTAURANT}/getFranchiseRestaurantsByIds`

export const RESTO365_UPDATE_RESTAURANT = `${RESTO365_RESTAURANT}/update365Restro`

export const RESTO365_UPDATE_RESTAURANT_SUSTAINABILITY = `${RESTO365_RESTAURANT}/updateRestaurantSustainability`

export const RESTO365_RESTAURANT_LICENSE_LIST = `${RESTO365_RESTAURANT}/getLicenseList`

export const RESTO365_RESTAURANT_CREATE_LICENSE_LIST = `${RESTO365_RESTAURANT}/createLicenseData`

export const RESTO365_RESTAURANT_UPDATE_LICENSE_LIST = `${RESTO365_RESTAURANT}/updateLicenseData`

export const RESTO365_RESTAURANT_UPDATE_LICENSE_UPLOAD = `${RESTO365_RESTAURANT}/uploadLicenseFile`

export const RESTO365_RESTAURANT_COMMON_SEARCH = `${RESTO365_RESTAURANT}/commonSearchInitialData`

export const RESTO365_RESTAURANT_COMMON_SEARCH_UPDATE = `${RESTO365_RESTAURANT}/commonSearchUpdateData`

export const RESTO365_RESTAURANT_RESET_REDUCER = `${RESTO365_RESTAURANT}/resetReducers`

export const RESTO365_RESTAURANT_ERROR_RESET = `${RESTO365_RESTAURANT}/errorReset`

export const RESTO365_RESTAURANT_UPDATE_FRANCHISE_ID = `${RESTO365_RESTAURANT}/updateFranchiseId`

export const RESTO365_RESTAURANT_UPDATE_TEST_MODE = `${RESTO365_RESTAURANT}/updateTestMode`

export const RESTO365_VALIDATE_YEXT_ENTITY_ID = `${RESTO365_RESTAURANT}/validateYextEntityId`

export const RESTO365_VALIDATE_GOOGLE_PLACES_ADDRESS = `${RESTO365_RESTAURANT}/validateGooglePlacesAddress`
